export const ServicesAgreementStatus = {
  COMPLETED: 'Completed',
  PENDING_SIGNATURES: 'Pending signatures',
  IN_REVIEW: 'In review',
}

export const ServicesAgreementSubmissionType = {
  NEW_AGREEMENT_WET_SIGN: 'newAgreementWetSign',
  NEW_AGREEMENT_ELECTRONIC_OR_ESIGN: 'newAgreementTaxable',
  EXISTING_AGREEMENT: 'existingAgreement',
  GENERATE_DOCUMENT: 'generateDocument',
  GENERATE_DOCUMENT_EXISTING: 'generateDocumentExisting',
}

export const TAXABLE_ACCOUNTS_AGREEMENT_UPLOAD_INSTRUCTIONS = `Once you upload your signed agreement, we’ll review it within 1–2 days. Note that modifications to your agreement can’t be made on the platform and may cause delays. If you have questions, reach out to your relationship manager.`

export const TAXABLE_ACCOUNTS_INITIAL_INVESTMENT_TOOLTIP_CONTENT =
  'Initial investment of taxable custodial account (Federated Government Obligations Fund or such similar money market mutual fund as we may make available from time to time for the investment of funds in a custodial account).'
